/**
 * @param {string|number|Date} isoOrDate
 * @param {(key: string, vars?: object) => string} t
 */
export function formatRelativeTime(isoOrDate, t) {
  let d;
  try {
    d = isoOrDate instanceof Date ? isoOrDate : new Date(isoOrDate);
  } catch {
    return '';
  }
  if (Number.isNaN(d.getTime())) return '';

  const now = new Date();
  const diffMs = now.getTime() - d.getTime();
  const sec = Math.floor(diffMs / 1000);
  if (sec < 60) return t('time.relative.justNow');
  const min = Math.floor(sec / 60);
  if (min < 60) return t('time.relative.minutesAgo').replace('{n}', String(min));
  const hours = Math.floor(min / 60);
  if (hours < 24 && now.toDateString() === d.toDateString()) {
    const time = d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    return t('time.relative.todayAt').replace('{time}', time);
  }
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  if (d.toDateString() === yesterday.toDateString()) return t('time.relative.yesterday');
  if (diffMs < 7 * 24 * 60 * 60 * 1000) {
    return d.toLocaleDateString([], { weekday: 'short', day: 'numeric', month: 'short' });
  }
  return d.toLocaleDateString([], { day: 'numeric', month: 'short', year: 'numeric' });
}
